import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-refund-create-button',
  templateUrl: './refund-create-button.component.html',
  styleUrls: ['./refund-create-button.component.scss']
})
export class RefundCreateButtonComponent {
 @Input() buypointId: string | undefined
 @Input() classIn: string | undefined
}
